import React, { Suspense, useContext } from 'react';
import DndDroppabableComponent from '../editor/DndDroppabableComponent';
import { ElementConfigType } from '../store/type'
import { PageEditorStoreContext } from '../store/PageEditorStore';
import { MyComponentType } from '@/pages2/DetailedDescription/component-factory/component-types';
import { toJS } from 'mobx';
import { ComponentIdEnum } from '@/pages2/DetailedDescription/component-factory/ComponentIdEnum';
import { lazy } from 'ice';

import { ConfigHOC } from '../HOC';

type Props = ElementConfigType;

export const BodyComponent: MyComponentType<Props> = (props: Props) => {
  const pageEditorStore = useContext(PageEditorStoreContext);
  const { elements, nodeId, privateSchema, id } = props;

  return (
    <div className={'flex flex-col w-full mx-auto bg-white'} style={Object.assign({}, { ...privateSchema })} id={id}>
      {elements.map((item) => (
        <props.ComponentItemRender {...toJS(item)} key={item.nodeId} />
      ))}

      {!pageEditorStore.isRenderHtml && (
        <div className={'h-40 w-full p-2 border border-dashed'}>
          <DndDroppabableComponent droppableId={nodeId} />
        </div>
      )}
    </div>
  );
};

const ConfigForm = lazy(() => import('../components-with-definition/BodyComponentDefinition'));

BodyComponent.definition = {
  // id: 'body-component', // 最大父容器 设计它是为了 可以设计它的最大宽度 以方便创造 web大屏 iPad中屏 移动端小屏的详描 id不可随便更改
  id: ComponentIdEnum.BODY_COMPONENT, // 最大父容器 设计它是为了 可以设计它的最大宽度 以方便创造 web大屏 iPad中屏 移动端小屏的详描 id不可随便更改
  name: '主页面容器',
  icon: '',
  hidden: true,
  config: {},
  privateSchema: {
    maxWidth: '1354px', // 初始值
  },
  category: 'other',
  configForm: ConfigHOC(ConfigForm),
};
